import { useState, useEffect } from 'react';

export interface PasswordRequirement {
  id: string;
  label: string;
  test: (password: string) => boolean;
  met: boolean;
}

export const usePasswordValidation = (password: string = '') => {
  const [requirements, setRequirements] = useState<PasswordRequirement[]>([
    {
      id: 'length',
      label: 'At least 8 characters',
      test: (pwd) => pwd.length >= 8,
      met: false,
    },
    {
      id: 'uppercase',
      label: 'One uppercase letter',
      test: (pwd) => /[A-Z]/.test(pwd),
      met: false,
    },
    {
      id: 'lowercase',
      label: 'One lowercase letter',
      test: (pwd) => /[a-z]/.test(pwd),
      met: false,
    },
    {
      id: 'number',
      label: 'One number',
      test: (pwd) => /\d/.test(pwd),
      met: false,
    },
    {
      id: 'special',
      label: 'One special character (@, -, _, !, etc.)',
      test: (pwd) => /[@\-_!#$%^&*(),.?":{}|<>]/.test(pwd),
      met: false,
    },
  ]);

  useEffect(() => {
    setRequirements(prev =>
      prev.map(req => ({
        ...req,
        met: req.test(password),
      }))
    );
  }, [password]);

  const allRequirementsMet = requirements.every(req => req.met);

  return {
    requirements,
    allRequirementsMet,
  };
};